/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Mobile_Delete_Pages_PromptInputs */

const en_mobile_delete_pages_prompt = /** @type {(inputs: Mobile_Delete_Pages_PromptInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Delete ${i?.count} page?`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Delete ${i?.count} pages?`);
	return /** @type {LocalizedString} */ ("mobile_delete_pages_prompt");
};

const es_mobile_delete_pages_prompt = /** @type {(inputs: Mobile_Delete_Pages_PromptInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`¿Eliminar ${i?.count} página?`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`¿Eliminar ${i?.count} páginas?`);
	return /** @type {LocalizedString} */ ("mobile_delete_pages_prompt");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Delete {count} page?" |
* | "other" | "Delete {count} pages?" |
*
* @param {Mobile_Delete_Pages_PromptInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_delete_pages_prompt = /** @type {((inputs: Mobile_Delete_Pages_PromptInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Delete_Pages_PromptInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_delete_pages_prompt(inputs)
	return en_mobile_delete_pages_prompt(inputs)
});